import { FC, PropsWithChildren } from 'react';

import CookiesPolicy from 'src/components/CookiesPolicy';
import Metatags from 'src/components/Metatags';
import ThemeContainer, { ThemeContainerProps } from 'src/components/ThemeContainer';
import { useUxFeedbackProfessionBasedSurvey } from 'src/hooks/useUxFeedbackProfessionBasedSurvey';

interface Props {
    themeContainerProps?: ThemeContainerProps;
}

const PageWrapper: FC<PropsWithChildren<Props>> = ({ themeContainerProps, children }) => {
    useUxFeedbackProfessionBasedSurvey();
    return (
        <ThemeContainer {...themeContainerProps}>
            <Metatags />
            <CookiesPolicy />
            {children}
        </ThemeContainer>
    );
};

export default PageWrapper;
